import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUsername = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	viewBox: "0 0 17 17",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M7.05 2.95h-5c-.6 0-1 .4-1 1v11c0 .6.4 1 1 1h13c.6 0 1-.4 1-1v-11c0-.6-.4-1-1-1h-5" }),
		/* @__PURE__ */ _jsx("path", { d: "M10.05 2.45c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5v2c0 .3.2.5.5.5h2c.3 0 .5-.2.5-.5z" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8.45,
			cy: 9.25,
			r: 2.2
		}),
		/* @__PURE__ */ _jsx("path", { d: "M12.45 15.95c-.3-2.2-2.3-3.8-4.5-3.5-1.8.2-3.2 1.7-3.5 3.5" })
	]
});
export { SvgUsername as ReactComponent };
